// extracted by mini-css-extract-plugin
export var links = "iso-accreditations-module--links--02c1d";
export var text = "iso-accreditations-module--text--31125";
export var title = "iso-accreditations-module--title--0dd98";